import React from "react"
import { useRouter } from "next/router"
import { Col, Form } from "react-bootstrap"

function AvailableOnlyField() {
    const router = useRouter()
    const { available_only } = router.query

    return (
        <Col sm={6} className="d-flex align-items-end pb-1">
            <Form.Check
                type="checkbox"
                id="available-only"
                label="Show available only"
                checked={available_only === "true"}
                onChange={(e) => {
                    if (e.target.checked) {
                        router.query.available_only = "true"
                    } else {
                        delete router.query.available_only
                    }
                    router.query.page = 1
                    router.push(router)
                }}
            />
        </Col>
    )
}

export default AvailableOnlyField
